module.exports = __webpack_public_path__ + "img/process4.3b334d97.png";